import React from 'react';
import './Job1.css';
import { Container } from 'react-bootstrap';
import Footer from './Footer';

const Job1 = () => {
    return (
        <>
        <div style={{textAlign:'justify'}}>
            <br/><br/>
            <Container>
            <h2>Campus Ambassador Job Description</h2>
            <p>We are seeking enthusiastic and motivated students to join our team as Campus Ambassadors. As a Campus Ambassador, you will represent our organization within Rajasthan Technical University (RTU) affiliated colleges. You will play a crucial role in promoting our study materials and engaging with students to provide them with valuable resources.</p>

            <br/>
            <h3>Responsibilities:</h3>
            <ul>
                <li className='points_rem'>Promote our brand and initiatives within the RTU student community.</li>
                <li className='points_rem'>Engage with students through social media platforms, college groups, and other channels to raise awareness about our offerings.</li>
                <li className='points_rem'>Share updates, announcements, and relevant content through social media platforms and college WhatsApp groups.</li>
                <li className='points_rem'>Encourage students to utilize our platform to enhance their learning experience and academic performance.</li>
                <li className='points_rem'>Gather feedback from classmates about our website and services.</li>
                <li className='points_rem'>Act as a point of contact for students seeking assistance or information about our study materials.</li>
            </ul>

            <br/>

            <h3>Requirements:</h3>
            <ul>
                <li className='points_rem'>Proficiency in Adobe Creative Suite (Photoshop, Illustrator, InDesign)</li>
                <li className='points_rem'>Strong design skills and attention to detail</li>
                <li className='points_rem'>Ability to work independently and as part of a team</li>
                <li className='points_rem'>Excellent communication and time management skills</li>
            </ul>

            <br/>

            <h3>Perks:</h3>
            <ul>
                <li className='points_rem'>Opportunity to work on real-world projects and build your portfolio</li>
                <li className='points_rem'>Learn from experienced professionals in the field</li>
                <li className='points_rem'>Flexible hours to accommodate your schedule</li>
                <li className='points_rem'>Remote work</li>
                <li className='points_rem'>Certificate of completion provided upon successful internship completion</li>
                <li className='points_rem'>Stipend: Unpaid</li>
            </ul>
            <br/>

            <p>Send your Resume on <a href="mailto:quicklearn-rtu@gmail.com">email</a></p>
            </Container>

            <hr/>
            <Footer/>
        </div>
        </>
    );
}

export default Job1;
